import { Suspense, lazy, useCallback, useMemo, useRef, useState, type ReactNode } from "react";

import { Icon } from "../../components/Icon";
import { AssistantContext } from "./AssistantContext";
import "./assistant.css";

const AssistantWidget = lazy(() => import("./AssistantWidget"));

/**
 * Floating "Assistent" button plus context for pages (Hilfe). The side
 * sheet itself loads on first open so the shell bundle stays small.
 */
export function AssistantHost({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);
  const fabRef = useRef<HTMLButtonElement>(null);
  const close = useCallback(() => {
    setOpen(false);
    fabRef.current?.focus();
  }, []);
  const value = useMemo(
    () => ({ isOpen: open, open: () => setOpen(true), close }),
    [open, close],
  );
  return (
    <AssistantContext.Provider value={value}>
      {children}
      <button
        ref={fabRef}
        type="button"
        className="asst-fab"
        aria-label="Assistent"
        aria-haspopup="dialog"
        aria-expanded={open}
        onClick={open ? close : value.open}
      >
        <Icon name="bot" size={18} />
        <span className="asst-fab-label">Assistent</span>
      </button>
      {open ? (
        <Suspense fallback={null}>
          <AssistantWidget onClose={close} />
        </Suspense>
      ) : null}
    </AssistantContext.Provider>
  );
}
